import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { LanguageService } from '../language.service';

/**
 * Loads a domain's translation scope before its routes render.
 *
 * ```ts
 * { path: 'master', resolve: { i18n: i18nScope('master') }, children: [...] }
 * ```
 *
 * Blocking navigation on one small JSON fetch is what removes the raw-key flash entirely. The
 * scope is also re-loaded on every language switch, because `setLanguage()` reloads every scope
 * that has been registered before it flips.
 *
 * ⚠️ Attach this by the folder the route's `loadComponent()` actually imports from — NOT by the
 * route's path. `app.routes.ts` has at least one path whose name does not match the folder it
 * loads (a nested `sales` path under `master` carrying the `Maestros` breadcrumb). Getting this
 * wrong loads the wrong scope, and the screen renders raw keys.
 */
export const i18nScope =
  (scope: string): ResolveFn<boolean> =>
  () =>
    inject(LanguageService)
      .useScope(scope)
      .then(() => true);
